import {
  UPDATE_HOW_TO_VIDEOS_LIST,
  UPDATE_HOW_TO_VIDEOS_LOADING,
} from "../../store/actionTypes";

const initialState = {
  total: 0,
  pageNo: 1,
  limit: 6,
  totalPage: 0,
  howToVideosList: [],
  isLoading: false,
};

const HowToVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_HOW_TO_VIDEOS_LIST: {
      return { ...state, ...action.payload };
    }
    case UPDATE_HOW_TO_VIDEOS_LOADING: {
      return { ...state, isLoading: !state.isLoading };
    }
    default:
      return state;
  }
};

export default HowToVideosReducer;
